import { useEffect, useState } from "react";
import axios from "axios";
import { Autocomplete, IconButton, MenuItem, Switch, TextField, Tooltip } from "@mui/material";

export default function SelectCompetencies({formik}) {
    const [isAssessmentSent, setIsAssessmentSent] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [competencies, setCompetencies] = useState([]);
    const [showTemplatesList, setShowTemplatesList] = useState(false);
    const [showCompetencyList, setShowCompetencyList] = useState(false);
    const [checkedQuestions, setCheckedQuestions] = useState([]);
    const [checkedCompetencies, setCheckedCompetencies] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(formik.values.survey);
    const [accordion, setAccordion] = useState({});
    const [isChange, setIsChange] = useState(false)

    useEffect(() => {  
        console.log("formik", formik.values)       
        getTemplates();
        if(formik.values.template > 0){
            setShowTemplatesList(true)
            if(formik.values.templateType === 'Default'){
                getSurveyCompetencies(formik.values.template)
            }
        }
        else{
            getCompetencies()
        }
        if(formik.values.templateType === 'Manual'){
            setShowCompetencyList(true)
            setCheckedQuestions(formik.values.questions)
        }
    }, [])

    const getTemplates = async() => {
        await axios.get(`/api/surveys?status=1&isList=1`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setTemplates(result.data)
                console.log(templates)
            }
        })
    }

    const getCompetencies = async(templateId='') => {
        await axios.get(`/api/competencies?templateId=${templateId}&orgId=${formik.values.team?.id}`).then(function (response) {
            let result = response.data;
            if (result.success) {
                // console.log("result.data-----------------",result.data)
                setCompetencies(result.data);
                // if(formik.values.templateType === 'Default' && selectedTemplate !==''){
                //     const questionIds = [];
                //     for (const competency of result.data) {
                //         for (const question of competency.questions) {
                //             questionIds.push(question.id);
                //         }
                //     }
                //     console.log("questionIds-----------------",questionIds)
                //     formik.setFieldValue('questions', questionIds)
                // }
            } else {
                // Handle error or set isError state if needed.
            }
        });
    }

    const getSurveyCompetencies = async (templateId) => {
        await axios.get(`/api/singleSurvey?id=${templateId}`).then(function (response) {
            let result = response.data;
            if (result.success) {
                // console.log("result.data-----------------",result.data)
                let survey_competencies = result.data.survey_competencies
                let data = []
                for(let i = 0; survey_competencies.length > i; i++){
                    let survey_competency_questions = survey_competencies[i].survey_competency_questions
                    let questions = []
                    for(let i = 0; survey_competency_questions.length > i; i++){
                        questions.push(survey_competency_questions[i].question)
                    }
                    data.push({
                        id: survey_competencies[i].competencyId,
                        name: survey_competencies[i].competency.name,
                        questions: questions
                    })
                }
                setCompetencies(data);
                if(formik.values.templateType === 'Default' && selectedTemplate !==''){
                    const questionIds = [];
                    for (const competency of data) {
                        for (const question of competency.questions) {
                            questionIds.push(question.id);
                        }
                    }
                    console.log("questionIds-----------------",questionIds)
                    formik.setFieldValue('questions', questionIds)
                }
            } else {
                // Handle error or set isError state if needed.
            }
        });
    }

    const handleTemplatesChange = async (e, value) => {
        if(value){
            setSelectedTemplate(value)
            formik.setFieldValue('template', value.id)
            formik.setFieldValue("name", value.name);
            getSurveyCompetencies(value.id)
            // if(formik.values.templateType === 'FromTemplate'){
            //     setShowCompetencyList(true)
            // }
        }
        else{
            setSelectedTemplate(null);
            formik.setFieldValue('template', '')
            formik.setFieldValue("name", "");
        }
        
    }

    const handleTemplateTypeSelection = async (e) => {
        setCheckedQuestions([])
        setCheckedCompetencies([])
        const value = e.target.value;
        setShowTemplatesList(value === 'Default');
        setShowCompetencyList(value === 'Manual');
        setSelectedTemplate(null)
        formik.setFieldValue('templateType', e.target.value);    
        formik.setFieldValue('template', '')
        formik.setFieldValue('questions', [])
        if(value === 'Manual'){
            formik.setFieldValue("name", "");            
            getCompetencies()
        }

        if (value === "Default") {
            // Clear name until template selected
            formik.setFieldValue("name", "");
            setShowTemplatesList(true);
            setShowCompetencyList(false);
        }
        
    };

    useEffect(() => {
        formik.submitForm()        
    }, [formik.values.templateType])

    const handleCompetencyCheck = (e, competencyId) => {
        const isChecked = checkedCompetencies.includes(competencyId);
    
        // Get the questions of the competency
        const competencyQuestions = competencies.find(comp => comp.id === competencyId)?.questions.map(question => question.id) || [];
    
        if (isChecked) {
            // Remove questions of the competency from checkedQuestions
            const updatedCheckedQuestions = checkedQuestions.filter(questionId => !competencyQuestions.includes(questionId));
            
            // Update state and formik field value
            setCheckedCompetencies(checkedCompetencies.filter(id => id !== competencyId));
            setCheckedQuestions(updatedCheckedQuestions);
            formik.setFieldValue('questions', updatedCheckedQuestions);
        } else {
            // Add questions of the competency to checkedQuestions
            const updatedCheckedQuestions = [...checkedQuestions, ...competencyQuestions];
    
            // Update state and formik field value
            setCheckedCompetencies([...checkedCompetencies, competencyId]);
            setCheckedQuestions(updatedCheckedQuestions);
            formik.setFieldValue('questions', updatedCheckedQuestions);
        }
    };

    const handleAccordionChange = (key) => {
        if(accordion && accordion[key]){
            accordion[key] = !accordion[key]
        }
        else{
            accordion[key] = true
        }
        setIsChange((prev) => !prev);
    }

    const handleQuestionChange = (e, value, competencyId) => {
        let questions = formik.values.questions
        if(e.target.checked){
            questions.push(value)
        }
        else{            
            const index = questions.indexOf(value);
            if (index > -1) {
                questions.splice(index, 1)
            }
        }
        setCheckedQuestions(questions)
        formik.setFieldValue('questions', questions)
        

        const isChecked = checkedCompetencies.includes(competencyId);
        // Get the questions of the competency
        const competencyQuestions = competencies.find(comp => comp.id === competencyId)?.questions.map(question => question.id) || [];
        // Remove questions of the competency from checkedQuestions
        const alreadyCheckedQuestions = checkedQuestions.filter(questionId => competencyQuestions.includes(questionId));        

        if (isChecked && competencyQuestions.length !== alreadyCheckedQuestions.length ) {            
            setCheckedCompetencies(checkedCompetencies.filter(id => id !== competencyId));
        }
        if (competencyQuestions.length === alreadyCheckedQuestions.length ) {            
            setCheckedCompetencies([...checkedCompetencies, competencyId]);
        }
    }


    return (
        <div className="row py-4">
            <div className="col-md-6 offset-md-3 mt-4">
                <h3 className="heading fs_20">Select Competencies</h3>
                <label className="form-label d-block">Select Survey Type</label>
                <div className="form-check form-check-inline mt-1">
                    <input disabled={isAssessmentSent?true:false} className="form-check-input" type="radio" name="templateType" id="inlineRadio1" value="Default" onChange={handleTemplateTypeSelection} checked={formik.values.templateType === 'Default' ? true : false }/>
                    <label className="form-check-label" htmlFor="inlineRadio1">Default Template</label>
                </div>
                <div className="form-check form-check-inline">
                    <input disabled={isAssessmentSent?true:false} className="form-check-input" type="radio" name="templateType" id="inlineRadio2" value="Manual" onChange={handleTemplateTypeSelection} checked={formik.values.templateType === 'Manual' ? true : false }/>
                    <label className="form-check-label" htmlFor="inlineRadio2">Manual</label>
                </div>
                {/* <div className="form-check form-check-inline">
                    <input disabled={isAssessmentSent?true:false} className="form-check-input" type="radio" name="templateType" id="inlineRadio3" value="FromTemplate" onChange={handleTemplateTypeSelection} checked={formik.values.templateType === 'FromTemplate' ? true : false }/>
                    <label className="form-check-label" htmlFor="inlineRadio3">From Template</label>
                </div> */}
                {formik.errors.templateType && formik.touched.templateType && (
                    <div className="text-danger">{formik.errors.templateType}</div>
                )}                                       
            </div>
            {/* Assessment Name (Only for Manual) */}
            {formik.values.templateType === "Manual" && (
                <div className="col-md-6 offset-md-3 mt-4">
                    <label className="form-label">Assessment Name</label>
                    <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Enter Assessment Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                        <div className="text-danger">{formik.errors.name}</div>
                    )}
                </div>
            )}
            <div className={`col-md-6 offset-md-3 mt-4 ${showTemplatesList ? "d-block" : "d-none" }`}>
                <div className="col-md-12 mb-3">
                    <label className="form-label" htmlFor="basic-icon-default-phone">Select Template</label>                                            
                    <Autocomplete
                        name="template"
                        id="combo-box-demo"
                        sx={{ width: 'auto' }}
                        size='small'
                        options={templates}
                        getOptionLabel={(option) => option.name}
                        onChange={handleTemplatesChange}
                        // value={formik.values.template}
                        value={selectedTemplate}
                        disabled={isAssessmentSent?true:false}
                        renderInput={(params) => <TextField {...params} label={"Please Select"} />}                                                    
                    />
                    {formik.errors.template && formik.touched.template && (
                        <div className="text-danger">{formik.errors.template}</div>
                    )}
                </div>                                              
            </div>                                     
            <div className={`col-md-6 offset-md-3 mt-4 ${showCompetencyList ? "d-block" : "d-none" }`}>
                <div className="col-md mb-4 mb-md-0">
                    <div className="accordion" id="accordionExample">
                        {competencies.map((competency) => (
                        <div className="card accordion-item" key={competency.id}>
                            <h2 className="accordion-header d-flex align-items-center" id="headingOne">
                            <button className="btn-sm">
                                <div className="form-check form-check-inline">
                                    <input disabled={isAssessmentSent?true:false} className="form-check-input" type="checkbox" id={"inlineComp"+competency.id} value="option2" onChange={(e) => handleCompetencyCheck(e, competency.id)} checked={checkedCompetencies.includes(competency.id)}/>
                                    <label className="form-check-label" htmlFor={"inlineComp"+competency.id}></label>
                                </div>
                            </button>                                                        
                                <button type="button" onClick={() => handleAccordionChange("accordion"+competency.id)} className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target={"#accordion"+competency.id} aria-expanded="false" aria-controls={"accordion"+competency.id}>
                                    {competency.name}
                                </button>                                                        
                            </h2>

                            <div id={"accordion"+competency.id} className={accordion && accordion["accordion"+competency.id] ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <div className="table-responsive text-nowrap">
                                        <table className="table ">
                                            <thead>
                                                <tr>
                                                    <th className="fw-bold">Select</th>
                                                    <th className="fw-bold">Question Type</th>
                                                    <th className="fw-bold">Question</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-border-bottom-0">
                                                {competency.questions && competency.questions.length > 0 ?
                                                competency.questions.map((question) => (
                                                <tr key={"questions-tr"+question.id}>
                                                    <td>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                name="questions"
                                                                className="form-check-input"
                                                                type="checkbox" 
                                                                id={"inlineCheckbox"+question.id}
                                                                data-competencyid={competency.id}
                                                                onChange={(e)=>handleQuestionChange(e, question.id, competency.id)}
                                                                disabled={isAssessmentSent?true:false}
                                                                checked={checkedQuestions.includes(question.id)}
                                                            />
                                                            <label className="form-check-label" htmlFor={"inlineCheckbox"+question.id}></label>
                                                        </div>
                                                    </td>
                                                    <td><i className="fab fa-angular fa-lg text-danger me-3"></i> <strong>{question.question_type && question.question_type.name ? question.question_type.name : ''}</strong></td>
                                                    <td>{question.name}</td>
                                                </tr>
                                                ))
                                                : 
                                                <tr key={"questions-tr0"}><td>No Question Available!</td></tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
                {formik.touched.questions && formik.errors.questions && (
                    <div className="text-danger">{formik.errors.questions}</div>
                )} 
            </div>
        </div>
    )
}